import { useEffect, useState } from 'react'
import Head from 'next/head'
import Script from 'next/script'
import {
  Footer,
  Header,
  TryEdworking,
  Testimonials,
  EdworkingPromotion,
  TopBanner,
} from '../../js/components'
import Image from 'next/image'
import Link from 'next/link'
import { OrganizationSchema, WebPageSchema, BreadcrumbListSchema } from '../../js/schemas'
import path from 'path'
import fs from 'fs/promises' // or 'fs' if using callbacks

export async function getStaticProps({ locale, locales }) {
  let content
  try {
    const filePath = path.join(process.cwd(), 'public', 'content', locale, 'reviews.json')

    // Read the file
    const jsonData = await fs.readFile(filePath, 'utf8')
    content = JSON.parse(jsonData)
  } catch (error) {
    console.error('error', error)
  }
  return {
    props: { content, locale, locales },
  }
}

export default function ReviewsLanding({ content, locale, locales }) {
  const [promotion, setPromotion] = useState(false)

  const onMouseOut = () => {
    const goon = localStorage.getItem('promotion')
    if (!goon) setPromotion(true)
    document.body.removeEventListener('mouseleave', onMouseOut)
  }

  useEffect(() => {
    setTimeout(function () {
      document.body.addEventListener('mouseleave', onMouseOut)
    }, 3000)
  }, [])

  return (
    <>
      <Script
        src="https://www.googletagmanager.com/gtag/js?id=UA-166939348-2"
        strategy="afterInteractive"
      />
      <Script id="google-analytics" strategy="afterInteractive">
        {`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            
            gtag('config', 'UA-166939348-2');
        `}
      </Script>
      <Script id="google-tag-manager" strategy="afterInteractive">
        {`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
            new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
            j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
            'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
            })(window,document,'script','dataLayer','GTM-NRW96HD');
        `}
      </Script>
      <Script id="hotjar" strategy="afterInteractive">
        {`
          (function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:2080824,hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
          })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
        `}
      </Script>
      <OrganizationSchema />
      <WebPageSchema name={content.head.title} description={content.head.description} />
      <BreadcrumbListSchema
        items={[
          {
            name: 'Home',
            url: `https://edworking.com/${locale !== 'en' ? `${locale}/` : ''}`,
          },
          {
            name: 'Reviews',
            url: `https://edworking.com/${locale !== 'en' ? `${locale}/` : ''}reviews`,
          },
        ]}
      />
      <Head>
        <title>{content.head.title}</title>
        <meta itemProp="name" content={content.head.title} />
        <meta itemProp="description" content={content.head.description} />
        <meta name="description" content={content.head.description} />
        <link rel="shortcut icon" href="/images/favicon.ico" />
        {locales.map((locale1, index) => (
          <link
            key={index}
            rel="alternate"
            hrefLang={locale1}
            href={`https://edworking.com${locale1 !== 'en' ? `/${locale1}` : ''}/reviews`}
          />
        ))}
        <link rel="alternate" href={`https://edworking.com/reviews`} hrefLang="x-default" />
        <link
          rel="canonical"
          href={`https://edworking.com/${locale !== 'en' ? `${locale}/` : ''}reviews`}
          key="canonical"
        />
      </Head>
      <noscript
        dangerouslySetInnerHTML={{
          __html: `<iframe src="https://www.googletagmanager.com/ns.html?id=GTM-NRW96HD" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
        }}
      />
      <EdworkingPromotion promotion={promotion} content={content.promotion} />
      {/*<TopBanner content={content.topbanner} />*/}
      <Header content={content.header} topbanner={true} />
      <IntroReviews content={content.intro} />
      <Reviews content={content.reviews} />
      <TryEdworking content={content.endbanner} />
      <Footer content={content.footer} />
      <div id="livenoti" className="livenoti"></div>
    </>
  )
}

const IntroReviews = ({ content }) => {
  return (
    <section className="introlanding" style={{ width: '100%', marginBottom: 0 }}>
      <h1 className="title">{content.title}</h1>
      <h2 className="description">{content.description}</h2>
    </section>
  )
} //		<div className="barcolors" style={{maxWidth: '100vw', width: '100%'}}></div>
export const colorsED = [
  '#FB8C72',
  '#34D7F8',
  '#D867C7',
  '#FBD067',
  '#47A1ED',
  '#4ED297',
  '#D5E1E4',
]

const Reviews = ({ content }) => {
  return (
    <section className="all-reviews" style={{ marginTop: 0 }}>
      {content.map((review, index) => (
        <div className="review-card" key={index} onClick={() => window.open(review.link)}>
          <Image
            width={25}
            height={25}
            src={`/images/reviews/${review.platform}.png`}
            className="platform"
            alt=""
          />
          <div className="author">
            {review.author.image !== '' ? (
              <Image width={50} height={50} src={review.author.image} alt="" />
            ) : (
              <div
                className="profile"
                style={{ background: colorsED[Math.floor(Math.random() * 7)] }}
              >
                {review.author.name.substring(0, 1)}
              </div>
            )}
            <div className="name">{review.author.name}</div>
            <div className="description">{review.author.description}</div>
            <div className="stars">
              {Array(5)
                .fill(null)
                .map((a, index) => (
                  <Image
                    width={16}
                    height={16}
                    key={index}
                    src={`/images/reviews/Star${
                      review.rate >= index + 1 ? 2 : review.rate >= index ? 1 : 0
                    }.svg`}
                    alt="user"
                  />
                ))}
            </div>
          </div>
          <div className="review">{review.review}</div>
        </div>
      ))}
    </section>
  )
}
